import React from "react";

import language from "../../localization";
import styles from "./style.module.css";

const cx = (...classes) => classes.filter(Boolean).join(" ");
const getDirection = (dir) => {
  if (dir) return dir;
  const currentLanguage = language.getLanguage?.() || "en";
  return language.getLanguageDirection?.(currentLanguage) || language.textDirection || "ltr";
};

const PageSkeleton = ({ className, message, dir }) => {
  const direction = getDirection(dir);
  const label = message || language.loading_page || language.loading_data || language.loading || "Loading page...";

  return (
    <section className={cx(styles.shell, className)} dir={direction} role="status" aria-live="polite" aria-busy="true">
      <div className={styles.inner}>
        <p className={styles.message}>{label}</p>
        <div className={styles.headerPreview} aria-hidden="true">
          <span className={cx(styles.skeleton, styles.kicker)} />
          <span className={cx(styles.skeleton, styles.title)} />
          <span className={cx(styles.skeleton, styles.text)} />
          <span className={cx(styles.skeleton, styles.shortText)} />
        </div>
        <div className={styles.gridPreview} aria-hidden="true">
          {[0, 1, 2].map((item) => (
            <article className={styles.cardPreview} key={item}>
              <span className={cx(styles.skeleton, styles.image)} />
              <span className={cx(styles.skeleton, styles.cardTitle)} />
              <span className={cx(styles.skeleton, styles.cardText)} />
              <span className={cx(styles.skeleton, styles.cardTextShort)} />
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PageSkeleton;
